/**
 * Tab Component
 *
 * @file tab.js
 */

import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  
  const defaultTab = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item");
    const tabsContents = document.querySelectorAll(".a-tab-content");
    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };
  

  const defaultFancybox = () => {
    const cookieModalClass = document.getElementById("cookie-dialog-content");
    Fancybox.bind('[data-fancybox]', {
      // Custom options for all galleries
      dragToClose: false,  // Sürüklemeyi devre dışı bırak
      on: {
        close: (fancybox, slide) => {
          cookieModalClass.classList.remove("d-block");
          cookieModalClass.classList.add("d-none");
        }
    }
    }); 
    $(".cookie-accept").on("click", function(){
      Fancybox.close();
    });
    
  };

  const cookieTab = () => {
    // Tüm tab item'ları seç
    $(".cookie-modal-tab .modal-tab-item").on("click", function(){
      $(".cookie-modal-tab .modal-tab-item").removeClass("active");
      $(this).addClass("active");
      $(".modal-tab-content").removeClass("tab-active");
      $(".modal-tab-content").eq($(this).index()).addClass("tab-active");
    });

    $("#cookie-all-cancel").on("click", function(){
      $(".footer-cookie-policy").remove();
    });
  };

  const init = () => {
    defaultTab();
    defaultFancybox();
    cookieTab();
  };

  return {
    init,
  };
})();

export default tabs;
